export const GOALS_STICKY_TOP_CLASS = "top-[var(--header-stack)]";
export const GOAL_TEXTAREA_MIN_HEIGHT_CLASS = "min-h-[calc(var(--space-8)*3)]";
